import { 
  STATUS_CLEAR_TO_CLOSE_COMPLETED, 
  STATUS_DOCS_IN_EPRINT, 
  STATUS_DOCS_IN_DOCUSIGN, 
  STATUS_SUBMITTED, 
  STATUS_NOI_SENT,
  STATUS_BOOKING_COMPLETE,
  STATUS_APPROVED_NOT_ACCEPTED,
  STATUS_CLOSED_FOR_INCOMPLETENESS,
  STATUS_CUSTOMER_WITHDRAWN,
  STATUS_WITHDRAW,
  STATUS_CREDIT_APPROVAL,
  STATUS_DECLINED,
  STATUS_DENIAL_UNDER_REVIEW,
  STATUS_SOFT_DECLINED
} from "src/services/constants";

const stageClearToCloseForCDP = {
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  children: [
    {
      stages: [
        {
          name: STATUS_DOCS_IN_EPRINT,
          display_name: STATUS_DOCS_IN_EPRINT,
        },
        {
          name: STATUS_DOCS_IN_DOCUSIGN,
          display_name: STATUS_DOCS_IN_DOCUSIGN,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ],
    },
  ],
};

const stageNOI = {
  name: STATUS_NOI_SENT,
  display_name: STATUS_NOI_SENT,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_NOI_SENT,
          display_name: STATUS_NOI_SENT,
          order: 1,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ],
    },
  ],
};

const stageDocsEPrintLoanCloseEdit = {
  name: STATUS_DOCS_IN_EPRINT,
  display_name: STATUS_DOCS_IN_EPRINT,
  children: [
    {
      stages: [
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_BOOKING_COMPLETE,
          display_name: STATUS_BOOKING_COMPLETE,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ],
    },
  ],
};

const stageDocsESignLoanCloseEdit = {
  name: STATUS_DOCS_IN_DOCUSIGN,
  display_name: STATUS_DOCS_IN_DOCUSIGN,
  children: [
    {
      stages: [
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_BOOKING_COMPLETE,
          display_name: STATUS_BOOKING_COMPLETE,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ],
    },
  ],
};

const stageApprovedNotAcceptedEdit = {
  name: STATUS_APPROVED_NOT_ACCEPTED,
  display_name: STATUS_APPROVED_NOT_ACCEPTED,
  children: [
    {
      stages: [
        {
          name: STATUS_BOOKING_COMPLETE,
          display_name: STATUS_BOOKING_COMPLETE,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ],
    },
  ],
};

const stageWithdrawn = {
  name: STATUS_WITHDRAW,
  display_name: STATUS_WITHDRAW,
  order_id: 2,
  children: [],
};

const stageClosedForIncomplete = {
  name: STATUS_CLOSED_FOR_INCOMPLETENESS,
  display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
  order_id: 2,
  children: [],
};

const stagePrequalificationWithdrawn = {
  name: STATUS_CUSTOMER_WITHDRAWN,
  display_name: STATUS_CUSTOMER_WITHDRAWN,
  order_id: 2,
  children: [],
};

const stageSoftDeclined = {
  name: STATUS_SOFT_DECLINED,
  display_name: STATUS_SOFT_DECLINED,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_CREDIT_APPROVAL,
          display_name: STATUS_CREDIT_APPROVAL,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
      ],
    },
  ],
};

export const rsntCommonStages = {
    stageClearToCloseForCDP,
    stageNOI,
    stageApprovedNotAcceptedEdit,
    stageDocsESignLoanCloseEdit,
    stageDocsEPrintLoanCloseEdit,
    stageWithdrawn,
    stageClosedForIncomplete,
    stagePrequalificationWithdrawn,
    stageSoftDeclined
}